export default {
	InvitationCode: "Código de Invitación",
	CreditScore: "Puntaje de Crédito",
	MyFinancial: {
		title: "Mis Finanzas",
		menu: ["Depósito", "Retiro", "Transacción"]
	},
	MyDetail: {
		title: "Mi Detalle",
		menu: ["Información Personal", "Métodos de Pago"]
	},
	Other: {
		title: "Otro",
		menu: ["Contáctenos", "Notificaciones", "Cambiar Idioma"]
	},
	Amount: ["Saldo de la Billetera", "Saldo Congelado", "Ganancias de Hoy"],
	Logout: {
		title: "Cerrar Sesión",
		content: "¿Estás seguro de que quieres cerrar sesión?"
	}
};
